/**
 * Created by mac on 7/24/17.
 */
const GoalView = cc.Node.extend({
    getStyles: function () {
        let styles = cleverapps.styles.BaseGoalView;

        if ([CoinCell.GOAL_ID].indexOf(this.goal.type) !== -1) {
            styles = cleverapps.overrideStyles(styles, {
                scaleX: Math.abs(styles.scaleX)
            }, true);
            styles.no_moves = cleverapps.overrideStyles(styles.no_moves, {
                scaleX: Math.abs(styles.no_moves.scaleX)
            }, true);
            styles.withTournament = cleverapps.overrideStyles(styles.withTournament, {
                scaleX: Math.abs(styles.withTournament.scaleX)
            }, true);
        }

        if (Game.currentGame.hasDanger()) {
            return styles.danger;
        }
        if (Game.currentGame && Game.currentGame.moves <= 0 && styles.no_moves && Game.currentGame.levelContent.moves > 0) {
            return styles.no_moves;
        }
        if (Game.currentGame.lightingRushMission) {
            return styles.withTournament;
        }

        return styles;
    },

    getTarget: function () {
        return this.icon;
    },

    ctor: function (goal, icon) {
        this._super();

        this.goal = goal;
        if (icon.cell) {
            this.cell = icon.cell;
        }

        this.amountType = this.getAmountType();

        this.icon = icon;
        this.icon.setLocalZOrder(0);

        const styles = this.getStyles();

        this.setContentSize(styles.width, styles.height);
        this.setAnchorPoint(0.5, 0.5);

        this.baseIconScaleX = styles.scaleX;
        this.baseIconScaleY = styles.scaleY;

        this.icon.setScale(this.baseIconScaleX, this.baseIconScaleY);

        this.icon.setAlignment(this.width / 2 + styles.icon.x, this.height - cleverapps.styles.BaseCellView.CELL_SIZE_PX * this.icon.scaleY / 2 + styles.icon.y);
        this.addChild(this.icon);

        if (!(goal instanceof Goal)) {
            return;
        }

        this.collected = goal.getAmount();

        this.amount = cleverapps.UI.generateImageText("", cleverapps.styles.FONTS.GOAL_TEXT);
        this.amount.setAlignment(this.width / 2 + styles.amount.x, styles.amount.y);
        this.amount.setLocalZOrder(1);
        this.addChild(this.amount);

        if (Game.currentGame.hasDanger()) {
            const progressBar = this.progressBar = this.createProgressBar();
            const goalBg = this.createGoalBg();

            this.addChild(progressBar, -1);
            this.addChild(goalBg, -1);

            this.icon.setPosition(goalBg.getPosition());

            this.amount.setAlignment(styles.progressBar.text);
            this.amount.setFont(cleverapps.styles.FONTS.DANGER_GOAL);
        }

        const checkMark = new cc.Sprite(bundles.checkbox.frames.check_mark_png);
        const checkMarkPos = this.amount.getPosition();
        const delta = styles.checkMarkOffset || cc.p(0, 0);
        checkMark.setAlignment(checkMarkPos.x + delta.x, checkMarkPos.y + delta.y);
        checkMark.setVisible(false);
        this.checkMark = checkMark;
        this.addChild(checkMark);

        this.update();

        goal.on("update", this.createListener(this.update.bind(this)));
        goal.on("beforeBonus", this.createListener(this.beforeAnimateBonus.bind(this)));
        goal.on("bonus", this.createListener(this.animateBonus.bind(this)));
        goal.on("onCollect", this.createListener(this.onCollect.bind(this)));
        goal.on("collect", this.createListener(this.animateCollect.bind(this)));
    },

    update: function (delta) {
        delta = delta || 0;
        this.collected += delta;
        let amount;

        if (this.amountType === GoalView.DISPLAYED_AMOUNT.TOTAL) {
            amount = this.collected;
        } else if (this.amountType === GoalView.DISPLAYED_AMOUNT.REMAINING) {
            amount = this.goal.getTarget() - this.collected;
        } else if (this.amountType === GoalView.DISPLAYED_AMOUNT.FRACTION) {
            amount = `${this.collected}/${this.goal.getTarget()}`;
        }

        this.amount.setString(amount);

        if (this.progressBar) {
            this.progressBar.setPercentage(this.collected);
        }

        if (cleverapps.config.editorMode) {
            return;
        }

        if (this.collected >= this.goal.getTarget() && this.goal.withTarget()) {
            this.setCompleted();
        } else {
            this.setIncompleted();
        }
    },

    createProgressBar: function () {
        const styles = this.getStyles();

        const progressBar = new ScaledProgressBar({
            progress: bundles.danger_component.frames.progress,
            background: bundles.danger_component.frames.progress_bg
        });

        progressBar.setLength(styles.progressBar.width);
        progressBar.setGoal(this.goal.getTarget());
        progressBar.setPercentage(this.collected);

        progressBar.setAlignment(styles.progressBar);

        return progressBar;
    },

    createGoalBg: function () {
        const styles = this.getStyles();

        const goalBg = this.goalBg = new cc.Sprite(bundles.danger_component.frames.goal_bg);
        goalBg.setAlignment(styles.goalBg);

        return goalBg;
    },

    setCompleted: function () {
        this.amount.setVisible(false);
        this.checkMark.setVisible(!this.uppedForStartAnimation);

        if (cleverapps.config.editorMode) {
            this.amount.setVisible(true);
            const delta = cleverapps.styles.BaseGoalView.editorModeCheckOffset;
            this.checkMark.setPosition(this.checkMark.x + delta.x, this.checkMark.y + delta.y);
        }

        cleverapps.effects.fire("match3.goal.complete");
    },

    setIncompleted: function () {
        this.amount.setVisible(!this.uppedForStartAnimation);
        this.checkMark.setVisible(false);
    },

    setFailed: function () {
        if (this.amount) {
            this.amount.setColor(cleverapps.styles.FONTS.ADDMOVES_GOAL_RED_TEXT.color);
        }
    },

    animateScale: function () {
        this.icon.stopAllActions();
        this.icon.setScale(this.baseIconScaleX * 1.2, this.baseIconScaleY * 1.2);
        this.icon.runAction(new cc.ScaleTo(0.2, this.baseIconScaleX, this.baseIconScaleY));
    },

    animateSmile: function () {
        if (!this.cell) {
            return;
        }

        const goalCoefComponent = this.cell.findComponent && this.cell.findComponent(GoalCoefComponent);
        if (this.cell.smile) {
            this.cell.smile();
        } else if (goalCoefComponent && goalCoefComponent.smile) {
            goalCoefComponent.smile();
        }
    },

    upForStartAnimation: function () {
        this.originalScale = this.scale;
        this.originalRotation = this.rotation;
        this.originalPosition = this.getPosition();
        this.originalParent = this.parent;

        this.scale = cleverapps.styles.GoalsView.startAnimation.goals.scale[cleverapps.resolution.mode];
        if (Game.currentGame.lightingRushMission) {
            this.scale *= Math.abs(cleverapps.styles.BaseGoalView.scaleY) / Math.abs(cleverapps.styles.BaseGoalView.withTournament.scaleY);
        }

        if (Game.currentGame.hasDanger()) {
            this.progressBar.visible = false;
            this.goalBg.visible = false;

            this.icon.setPosition(this.width / 2, this.height / 2);
        }
        if (this.life) {
            this.life.visible = false;
        }
        if (this.amount) {
            this.amount.visible = false;
        }

        this.rotation = 0;

        this.uppedForStartAnimation = true;
        this.removeFromParent(false);

        this.setVisible(true);
    },

    downFromStartAnimation: function () {
        this.replaceParent(this.originalParent);

        if (this.originalScale) {
            this.scale = this.originalScale;
            this.rotation = this.originalRotation;
            this.setPosition(this.originalPosition);
        }

        if (Game.currentGame && Game.currentGame.hasDanger()) {
            this.progressBar.visible = true;
            this.goalBg.visible = true;

            this.icon.setPosition(this.goalBg.getPosition());
        }

        if (this.life) {
            this.life.visible = true;
        }
        if (this.amount) {
            if (!this.goal.isCompleted()) {
                this.amount.visible = true;
            }
        }
        delete this.uppedForStartAnimation;
    },

    runStartAnimation: function (f, points, targetScale) {
        this.runAction(new cc.Sequence(
            new cc.Spawn(
                cleverapps.effects.fireAction("match3.goals.fly"),
                new cc.BezierTo(0.7, points).easing(cc.easeIn(1)),
                new cc.ScaleTo(0.7, targetScale.x, targetScale.y)
            ),
            new cc.Sequence(
                new cc.CallFunc(function () {
                    if (this.type === CoinCell.GOAL_ID) {
                        cleverapps.effects.fire("match3.coins.bonus");
                    }
                }),
                new cc.ScaleTo(0.1, targetScale.x + 0.15, targetScale.y - 0.15),
                new cc.ScaleTo(0.1, targetScale.x, targetScale.y)
            )
        )).setFinalize(() => {
            cleverapps.effects.fire("match3.goals.land");
            if (this.actor) {
                this.actor.animate(Actor.ANIMATIONS.IDLE);
            }
            if (this.life) {
                this.life.baseScale = this.life.getScale();

                this.life.setVisible(true);
                this.life.setScale(this.life.baseScale);
            }
            this.animateSmile();
            f();
        });
    },

    getTargetPosition: function (object) {
        if (this.cell && this.cell.getGoalTargetPosition) {
            return this.cell.getGoalTargetPosition(object.getRelativeCoordinates(this.getTarget()));
        }

        const styles = cleverapps.styles.BaseGoalView.collect.bySpine;
        if (styles) {
            const offset = styles[this.actor.currSpineId] || styles.default;

            return object.getParent().convertToNodeSpace(this.actor.getParent().convertToWorldSpace(cc.p(this.actor.x + offset.x, this.actor.y + offset.y)));
        }
    },

    goalCollectSound: function () {
        const soundLevels = [];

        for (let i = 0; i < 3; i++) {
            if (bundles.game.urls[`goal_inc_effect_${i}`]) {
                soundLevels.push(i);
            }
        }

        const soundLevel = PseudoRandom.GET().mathChoose(soundLevels);
        cleverapps.effects.fire(soundLevel ? `match3.goal.inc.${soundLevel}` : "match3.goal.inc");

        if (this.goal.isBonusElement()) {
            cleverapps.effects.fire("match3.coins.bonus");
        }
    },

    animateCollect: function (delta, flyIcon, options) {
        options = options || {};
        let target = this.icon;

        if (this.goal.isBonusElement()) {
            target = BonusLevelView.getTarget();
        }

        flyIcon.runAction(new cc.Sequence(
            StandartAnimations.animateCollect(flyIcon, target, {
                adjustToTarget: true
            })
        )).setFinalize(() => {
            flyIcon.removeFromParent();

            if (options.callback) {
                options.callback();
            }
            this.onCollect(delta);
        });
    },

    onCollect: function (delta) {
        this.update(delta);
        this.goalCollectSound();
        this.animateScale();
        this.animateSmile();
    },

    highlight: function () {
        cleverapps.effects.fire("match3.goal.highlight");

        const rays = new cleverapps.Spine(bundles.main.jsons.reward_spine_json);
        this.addChild(rays, -2);
        rays.setAlignment(this.width / 2, this.height / 2);
        rays.setAnimation(0, "animation", true);

        const pulseTime = 0.5;

        rays.setScale(0.15);
        rays.runAction(new cc.Sequence(
            new cc.ScaleTo(pulseTime / 2, 0.42),
            new cc.ScaleTo(pulseTime / 2, 0.15),
            new cc.RemoveSelf()
        ));

        this.icon.runAction(new cc.Sequence(
            new cc.ScaleTo(pulseTime / 2, this.baseIconScaleX * 1.3, this.baseIconScaleY * 1.3),
            new cc.ScaleTo(pulseTime / 2, this.baseIconScaleX, this.baseIconScaleY)
        ));
    },

    beforeAnimateBonus: function () {
        if (this.checkMark) {
            this.checkMark.setVisible(false);
        }
        if (this.amount) {
            this.amount.setVisible(false);
        }
        if (this.life) {
            this.life.setVisible(false);
        }
    },

    animateBonus: function (duration, oneCoinCallback, order) {
        const cell = this.cell;
        const ViewClass = cell.getViewClass();
        const icon = new ViewClass(cell);

        const bonusChestComponent = ComponentMap.getByName(cleverapps.Scenes.GetRunningScene(), "TriPeaksSceneComponent");
        const chest = bonusChestComponent && bonusChestComponent.bonusChest;

        const scaleX = this.baseIconScaleX || cleverapps.styles.BaseGoalView.icon.scale;
        const scaleY = this.baseIconScaleY || cleverapps.styles.BaseGoalView.icon.scale;
        if (this.actor) {
            icon.setScale(0);
            icon.setPosition(cleverapps.styles.BaseGoalView.bonus);
        } else {
            icon.setScale(scaleX, scaleY);
            icon.setPosition(this.icon.getPosition());
        }

        icon.animation.setAnimation(0, "fly", false);
        this.addChild(icon, this.goal.amount - order);

        const flyTarget = new cc.Node();
        flyTarget.setAnchorPoint(0.5, 0.5);
        flyTarget.setAlignment(chest.getFlyTargetPosition());
        chest.animation.addChild(flyTarget);

        icon.runAction(new cc.Sequence(
            StandartAnimations.animateCollect(icon, flyTarget, {
                duration: duration / 1000,
                randomPath: true
            }),
            new cc.CallFunc(() => {
                oneCoinCallback();
                chest.addGold();
            }),
            new cc.RemoveSelf()
        ));
    },

    getAmountType: function () {
        if (Game.currentGame.hasDanger() || cleverapps.config.editorMode) {
            return GoalView.DISPLAYED_AMOUNT.FRACTION;
        }
        if (this.goal.isBonusElement() || !this.goal.withTarget()) {
            return GoalView.DISPLAYED_AMOUNT.TOTAL;
        }

        return GoalView.DISPLAYED_AMOUNT.REMAINING;
    }
});

GoalView.FLY_SIGN = 1;

cleverapps.styles.BaseGoalView = {
    width: 100,
    height: 80,
    scaleX: 0.9,
    scaleY: 0.9,

    icon: {
        x: 0,
        y: 12,
        margin: {
            x: -15,
            y: 15
        }
    },

    amount: {
        x: 25,
        y: 10,
        scale: 0.8
    },

    editorModeCheckOffset: {
        x: 40,
        y: 40
    },

    bonus: {
        x: 70,
        y: 100
    },

    withTournament: {
        width: 60,
        height: 60,
        scaleX: 0.8,
        scaleY: 0.8,

        icon: {
            x: 0,
            y: 20
        },

        amount: {
            x: 25,
            y: 5,
            scale: 0.8
        }
    },

    no_moves: {
        width: 100,
        height: 80,
        scaleX: 1,
        scaleY: 1,

        icon: {
            x: 0,
            y: 12
        },

        amount: {
            x: 40,
            y: -30,
            scale: 1
        }
    },

    danger: {
        x: { align: "center" },
        y: { align: "center" },

        width: 375,
        height: 130,
        scaleX: 1,
        scaleY: 1,

        icon: {
            x: 0,
            y: 0
        },

        amount: {
            x: 0,
            y: 0,
            scale: 1
        },

        progressBar: {
            width: 345,

            x: { align: "center", dx: -90 },
            y: { align: "center", dy: -3 },

            text: {
                x: { align: "center", dx: -90 },
                y: { align: "center", dy: -1 }
            }
        },

        goalBg: {
            x: { align: "right" },
            y: { align: "center" }
        },

        checkMarkOffset: {
            x: 0,
            y: -7
        }
    }
};

cleverapps.styles.FONTS = cleverapps.overrideFonts(cleverapps.styles.FONTS, {
    DANGER_GOAL: {
        size: 45,
        stroke: cleverapps.styles.DECORATORS.LIGHT_TEXT_STROKE,
        shadow: cleverapps.styles.DECORATORS.LIGHT_TEXT_SHADOW
    }
});

GoalView.DISPLAYED_AMOUNT = {};
GoalView.DISPLAYED_AMOUNT.TOTAL = 0;
GoalView.DISPLAYED_AMOUNT.REMAINING = 1;
GoalView.DISPLAYED_AMOUNT.FRACTION = 2;
